// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"LanguageSelector_languageSelector__1nANX","select":"LanguageSelector_select__1qU8w"};